var Cookies = require('cookies-js')
var uuid = require('node-uuid')
var jQuery = require('jquery')
var $ = jQuery

module.exports = (function () {
  // filepicker.setKey('AD0m5WsumSZempJokkthiz');

  // Set/update unique browser id
  var existingBrowserId = Cookies.get('brid')
  var browserId = existingBrowserId || uuid.v4()
  Cookies.set('brid', browserId, { expires: (60 * 60 * 24) * 365 })
  window._app.browser_id = browserId
  window._app.session_id = uuid.v4();

  // jQuery plugin that checks if an element is visible on screen
  // https://github.com/teamdf/jquery-visible
  (function ($) {
    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *       the user visible viewport of a web browser.
     *       only accounts for vertical position, not horizontal.
     */
    var $w = $(window)
    $.fn.visible = function (opts) {
      if (this.length < 1) {
        return
      }

      var options = $.extend({
        partial: false,
        hidden: false,
        direction: 'both',
        offsetTop: 0,
        offsetBottom: 0,
        offsetLeft: 0,
        offsetRight: 0
      }, opts)

      var $t = this.length > 1 ? this.eq(0) : this
      var t = $t.get(0)
      var vpWidth = $w.width()
      var vpHeight = $w.height()
      var direction = options.direction
      var clientSize = options.hidden === true ? t.offsetWidth * t.offsetHeight : true

      var rec = t.getBoundingClientRect()
      var tViz = rec.top >= options.offsetTop && rec.top < vpHeight - options.offsetBottom
      var bViz = rec.bottom > options.offsetTop && rec.bottom <= vpHeight - options.offsetBottom
      var lViz = rec.left >= options.offsetLeft && rec.left < vpWidth - options.offsetRight
      var rViz = rec.right > options.offsetLeft && rec.right <= vpWidth - options.offsetRight
      var vVisible = options.partial ? tViz || bViz : tViz && bViz
      var hVisible = options.partial ? lViz || lViz : lViz && rViz

      if (direction === 'both') { return clientSize && vVisible && hVisible } else if (direction === 'vertical') { return clientSize && vVisible } else if (direction === 'horizontal') { return clientSize && hVisible }
    }
  })(jQuery)

  // jQuery scrollTo (element) plugin
  $.fn.scrollTo = function (target, options, callback) {
    if (typeof options === 'function' && arguments.length === 2) {
      callback = options
      options = target
    }
    var settings = $.extend({
      scrollTarget: target,
      force: false,
      usePosition: false,
      offsetTop: 0,
      duration: 0,
      easing: 'swing'
    }, options)
    return this.each(function () {
      var scrollPane = $(this)
      var scrollTarget = (typeof settings.scrollTarget === 'number') ? settings.scrollTarget : $(settings.scrollTarget)
      // var scrollY = (typeof scrollTarget === 'number') ? scrollTarget : scrollTarget.offset().top + scrollPane.scrollTop() - parseInt(settings.offsetTop);
      // var scrollY = (typeof scrollTarget === 'number') ? scrollTarget : scrollTarget.offset().top - parseInt(settings.offsetTop);
      var scrollY
      if (typeof scrollTarget === 'number') {
        scrollY = scrollTarget
      } else {
        if (settings.usePosition) {
          scrollY = scrollTarget.position().top
        } else {
          scrollY = scrollTarget.offset().top
        }
        scrollY -= parseInt(settings.offsetTop)
      }
      // console.log('scrollPane.scrollTop()', scrollPane.scrollTop());
      // console.log('scrollTarget.offset().top', scrollTarget.offset().top);
      // console.log('scrolling to', scrollY);
      if (settings.force || !scrollTarget.visible({offsetTop: settings.offsetTop, direction: 'vertical'})) {
        if (settings.duration === 0) {
          scrollPane.scrollTop(scrollY)
        } else {
          scrollPane.animate({scrollTop: scrollY}, parseInt(settings.duration), settings.easing, function () {
            if (typeof callback === 'function') {
              callback.call(this)
            }
          })
        }
      }
    })
  }
}())
